import { CodePensShowcase } from "components/showcases/CodePensShowcase"
import './CodePensPage.scss'

export const CodePensPage = () => {
    return (
        <div className="codepens">
            <h1 className="codepens__title">UI Components</h1>
            <section className="codepens__container">
                <CodePensShowcase />
            </section>
        </div>
    )
}